export const AppRoutes = {
  //auth
  signIn: '/sign-in',
  /** React Router splat — required for Clerk `routing="path"` sub-routes (e.g. /sign-in/factor-one). */
  signInSplat: '/sign-in/*',
  registerCompany: '/register-company',
  /** Splat for multi-step Paddle wizard if added later. */
  registerCompanySplat: '/register-company/*',
  signUp: '/sign-up',
  /** React Router splat — required for Clerk sub-routes (e.g. /sign-up/verify-email-address). */
  signUpSplat: '/sign-up/*',
  forgotPassword: '/forgot-password',
  createNewPassword: '/create-new-password',
  resetPassword: '/reset-password',
  contactUs: '/contact',
  cookies: '/cookies',
  verifyEmail: '/verify-email',
  onboardingForm: '/onboarding/form',
  stripeCallback: '/onboarding/stripe-callback',
  dashboard: '/dashboard',
  //single sends
  singleSends: '/single-sends/*',
  /** Hub page (picker); use in nav links without the splat. */
  singleSendsRoot: '/single-sends',
  buildMessage: '/build-message',
  newSMS: '/build-message/sms/new',
  newEmail: '/build-message/email/new',
  newPush: '/build-message/push/new',
  singleSendsMetrics: '/single-sends/metrics',

  home: '/',
  landing: '/landing',
  waitlist: '/waitlist',
  waitlistThankYou: '/waitlist/thank-you',
  riskAssessment: '/risk-assessment',
  pricing: '/pricing',
  changePhoneNumber: '/change-phone-number',
  nps: '/nps',
  campaigns: '/campaigns',
  createCampaign: '/campaigns/create',
  deleteCampaign: '/campaigns/:id/delete',
  delivery: '/delivery',
  audience: '/users',
  signals: '/signals',
  tickets: '/tickets',
  members: '/members',
  segments: '/user-groups',
  companies: '/companies',
  segmentOverview: '/user-groups/:id/overview',
  createSegment: '/user-groups/create',
  activityLogs: '/activity-logs',
  settings: '/settings',
  account: '/settings/account',
  personalAccount: '/settings/personal-account',
  apiCredentials: '/settings/api-credentials',
  createApiCredentials: '/settings/api-credentials/create',
  deleteApiCredentials: '/settings/api-credentials/:id/delete',
  teamMembers: '/settings/team-members',
  createTeamMember: '/settings/team-members/create',
  workspaces: '/workspaces',
  workspaceDetails: '/workspaces/:id',
  createWorkspace: '/workspaces/create',
  deleteWorkspace: '/workspaces/:id/delete',
  deleteAPICredentials: '/settings/api-credentials/:id/delete',
  editWorkspace: '/workspaces/:id/edit',
  memberProfile: '/members/:id',
  createMember: '/members/create',
  importMembers: '/members/import',
  templates: '/templates',
  templatesEdit: '/templates/:id/edit',
  createTemplate: '/templates/create',
  pushNotifications: '/settings/push-notifications',
  pushNotificationsEnableIos: '/settings/push-notifications/enable-ios',
  pushNotificationsEnableAndroid: '/settings/push-notifications/enable-android',
  deliveryOverview: '/delivery/:id',
  campaignOverview: '/campaigns/:id',
  templateOverview: '/templates/:id',
  help: '/help',
  domains: '/settings/domains',
  domainOverview: '/settings/domains/overview/:domainName',
  createDomain: '/settings/domains/create',
};
